import {intlShape} from '@wallaby-ui/core';
import {template} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';

import styles from './ReportSummaryItem.less';
import {
  SummaryReportData,
  REPORT_SUMMARY_DATA_TYPE_TEXT,
  REPORT_SUMMARY_DATA_TYPE_VALUE,
  REPORT_SUMMARY_DATA_TYPE_DATE,
} from 'src/js/model/reports_config';

class ReportSummaryItem extends React.PureComponent {
  render() {
    const {reportDataValues, data, intl} = this.props;
    const boundValues = SummaryReportData.mapBindings(
      reportDataValues,
      data.getDataBindings()
    );
    let renderedContent;
    if (data) {
      switch (data.getType()) {
        case REPORT_SUMMARY_DATA_TYPE_TEXT: {
          renderedContent = (
            <FormattedMessage
              id={data.getValue()}
              defaultMessage={data.getValue()}
              values={boundValues}
            />
          );
          break;
        }
        case REPORT_SUMMARY_DATA_TYPE_VALUE: {
          const compiledValue = template(data.getValue(), {
            interpolate: /{([\s\S]+?)}/g,
          });
          renderedContent = compiledValue(boundValues);
          break;
        }
        case REPORT_SUMMARY_DATA_TYPE_DATE: {
          const compiledValue = template(data.getValue(), {
            interpolate: /{([\s\S]+?)}/g,
          });
          renderedContent = intl.formatDate(compiledValue(boundValues));
          break;
        }
      }
    }

    return (
      <div className={styles.dlReportSummaryItem} data-name={data.getId()}>
        {data ? <span key={data.getId()}>{renderedContent}</span> : null}
      </div>
    );
  }
}

ReportSummaryItem.displayName = 'ReportSummaryItem';

ReportSummaryItem.propTypes = {
  intl: intlShape.isRequired,
  data: PropTypes.instanceOf(SummaryReportData).isRequired,
  reportDataValues: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default injectIntl(ReportSummaryItem);
